import { useWindowSize } from "usehooks-ts";

import { SCREEN_SM } from "@/style/breakpoints";

import type { ChatModel } from "@/models/chat/ChatModel";
import type { Editor } from "@tiptap/core";

export const isChatInputEmpty = (tiptap: Editor | null | undefined) => {
  const tiptapText = tiptap?.getText().trim() || "";
  const tiptapJson = tiptap?.getJSON();
  const content = tiptapJson?.content || [];
  return tiptapText.length === 0 && !content.map((node) => node.type).includes("image");
};

export const focusChatInput = (chat: ChatModel) => {
  chat.inputDoc.editor.tiptap?.commands.focus();
};

export const chatOptionsDropdownAttrs = (chat: ChatModel) => {
  return {
    panelDataAttributes: { "data-keep-chat-input-expanded": "" },
    onOpenChange: (open: boolean) => {
      if (!open) focusChatInput(chat);
    },
  };
};

export const useFloatingChatInputWidth = () => {
  const { width: windowWidth } = useWindowSize();

  return windowWidth < SCREEN_SM ? windowWidth - 80 : 600;
};

// Horizontal space around chat content — window paddings plus message bubble
// paddings and the avatar gutter (messages), or editor margins (input).
// Subtracted from the chat surface width to get the width math expressions may
// occupy before wrapping (passed to NodeStyleProvider).
const CHAT_MESSAGES_HORIZONTAL_PADDING = 100;
const CHAT_INPUT_HORIZONTAL_PADDING = 60;

export const getChatMessagesAvailableWidth = (surfaceWidth: number) =>
  surfaceWidth - CHAT_MESSAGES_HORIZONTAL_PADDING;

export const getChatInputAvailableWidth = (surfaceWidth: number) =>
  surfaceWidth - CHAT_INPUT_HORIZONTAL_PADDING;
